export default __webpack_public_path__ + "static/media/ai_img_3.9ad3ecdc.png";